import { useState, useEffect } from 'react';
import useAxios from 'axios-hooks';
import { useProgramContext } from 'providers/programProvider'
import { ORGANIZATION_SEARCH_DEFAULT_PARAMS } from 'utils/constants'

export const useOrganization = () => {
  const [state, dispatch] = useProgramContext()
  const [name, setName] = useState();
  const [id, setId] = useState();
  const [detailName, setDetailName] = useState();
  const [params, setParams] = useState()

  const [
    { data: dataDetail, loading: loadingDetail, error: errorDetail },
    executeDetail,
  ] = useAxios(
    { url: `organizations/details/`, params: { name } },
    { manual: !name }
  );

  useEffect(() => {
    if (!state.orgDetail && dataDetail) {
      dispatch({ type: 'SET_ORG_DETAIL', payload: dataDetail })
    }
  }, [dataDetail])

  const [
    { data: dataUpdate, loading: loadingUpdate, error: errorUpdate },
    executeUpdate,
  ] = useAxios(
    { url: `organizations/${id}`, method: 'PUT' },
    { manual: true }
  );

  const [
    { data: dataDetailOrganization, loading: loadingDetailOrganization, error: errorDetailOrganization },
    executeDetailOrganization,
  ] = useAxios(
    { url: `organizations/details`, params: { name: detailName } },
    { manual: !detailName }
  );

  //Organizations request
  const [
    {
      data: dataOrganizations,
      loading: loadingOrganizations,
      error: errorOrganizations,
    },
    executeOrganizations,
  ] = useAxios(
    { url: 'organizations', params },
    { manual: true }
  )

  useEffect(() => {
    if (params) {
      executeOrganizations()
    }
  }, [params])

  const getOrganizations = (filter) => {
    setParams({...ORGANIZATION_SEARCH_DEFAULT_PARAMS, ...params, ...filter})
  }

  return {
    dataDetail,
    loadingDetail,
    errorDetail,
    executeDetail,
    setName,
    dataUpdate,
    loadingUpdate,
    errorUpdate,
    executeUpdate,
    setId,
    name,
    dataDetailOrganization,
    loadingDetailOrganization,
    errorDetailOrganization,
    setDetailName,
    setParams,
    getOrganizations,
    dataOrganizations,
    loadingOrganizations,
    errorOrganizations,
  };
};
